import { AnyObject }       from 'antd/es/_util/type';
import { TColumnProps }    from './table';
import { parseEntryValue } from './parseEntryValue';
import moment              from 'moment';

export const getRawData = (item: AnyObject, columns: TColumnProps[]) => {
  const values: Record<string, unknown> = {};

  columns.filter(column => !!column).forEach(({ key, type, render }) => {
    const _render = render || ((value: any) => value);
    let value = parseEntryValue(_render(item[key], item));

    if(type) {
      switch(`${type}`.toLowerCase()) {
        case 'boolean'  : value = (!!(`${item[key]}`.match(/ja/i) || item[key] === true) ? 1 : 0); break;
        case 'float'    : value = !!item[key] ? parseFloat(item[key]) : null; break;
        case 'integer'  : value = !!item[key] ? parseInt(item[key]) : null; break;
        case 'date'     : value = (item[key]) ? moment(item[key]).format('YYYY-MM-DD') : '0'; break;
        case 'time'     : value = (item[key]) ? moment(item[key]).format('HH:mm:SS') : '0'; break;
        case 'datetime' : value = (item[key]) ? moment(item[key]).format('YYYY-MM-DD HH:mm:SS') : '0'; break;
        // no default
      }
    }
    values[`__${key}`] = value;
  });

  return values;
}
